import { JSX as LocalJSX } from '@ionic/core';
import { IonContent, IonFooter } from '@ionic/react';
import { ReactElement, useState } from 'react';
import { useMeasure } from 'react-use';
import {
  useKeyboardDidHide,
  useKeyboardWillShow,
} from '../../theme/keyboard.hook';
import './ui.css';

export interface ContentWithFooterProps {
  children: ReactElement;
  footer: ReactElement;
  forceHeightForFooter?: boolean;
  contentProps?: LocalJSX.IonContent;
}

const ContentWithFooter = (props: ContentWithFooterProps): ReactElement => {
  const { children, footer, forceHeightForFooter, contentProps } = props;

  const [footerRef, { height: footerHeight }] =
    useMeasure<HTMLIonFooterElement>();

  const [footerHidden, setFooterHidden] = useState<boolean>(false);

  useKeyboardWillShow((e) => {
    setFooterHidden(!e.isPhysicalKeyboard);
  });

  useKeyboardDidHide(() => {
    setFooterHidden(false);
  });

  const footerClass = footerHidden
    ? 'content-footer-hidden'
    : 'content-footer-show';

  return (
    <>
      <IonContent
        className="content-with-footer-content"
        style={{
          '--footer-height': `${forceHeightForFooter ? footerHeight : 0}px`,
        }}
        {...contentProps}
      >
        {children}
      </IonContent>
      <IonFooter ref={footerRef} className={footerClass}>
        {footer}
      </IonFooter>
    </>
  );
};

export { ContentWithFooter };
